/* eslint-disable @typescript-eslint/ban-ts-comment */
export type Env = {
  /*  */
  MODE: string;
  NODE_ENV: string;

  /*  */
  VITE_API_SETTINGS: string;

  VITE_APP_BASE_PATH: string;
  VITE_APP_BASE_PATH_SETTINGS: string;
  VITE_APP_KC_CLIENT_ID: string;
  VITE_APP_KC_REALM: string;
  VITE_APP_KC_URL: string;
  VITE_APP_SERVER_PORT: string;

  VITE_HOSTNAME: string;

  VITE_LAST_UPDATE: string;

  VITE_MINIORCH_ENDPOINT: string;
  VITE_MINIORCH_KC_CLIENT_ID: string;
  VITE_MINIORCH_KC_CLIENT_SECRET: string;
  VITE_MINIORCH_KC_REALM: string;
  VITE_MINIORCH_KC_URL: string;
  VITE_MINIORCH_KC_USER_NAME: string;
  VITE_MINIORCH_KC_USER_PASS: string;

  VITE_ROUTER_BASE_PATH: string;
};

type EnvVarsType =
  // @ts-ignore
  ProcessEnv | ImportMetaEnv | Env;

const envVarsBase = {
  MODE: '',
  NODE_ENV: '',

  /*  */
  VITE_API_SETTINGS: '',

  VITE_APP_BASE_PATH: '',
  VITE_APP_BASE_PATH_SETTINGS: '',
  VITE_APP_KC_CLIENT_ID: '',
  VITE_APP_KC_REALM: '',
  VITE_APP_KC_URL: '',
  VITE_APP_SERVER_PORT: '',

  VITE_HOSTNAME: '',

  VITE_LAST_UPDATE: '',

  VITE_MINIORCH_ENDPOINT: '',
  VITE_MINIORCH_KC_CLIENT_ID: '',
  VITE_MINIORCH_KC_CLIENT_SECRET: '',
  VITE_MINIORCH_KC_REALM: '',
  VITE_MINIORCH_KC_URL: '',
  VITE_MINIORCH_KC_USER_NAME: '',
  VITE_MINIORCH_KC_USER_PASS: '',

  VITE_ROUTER_BASE_PATH: '',
} as Env;

let envVars = { ...envVarsBase } as EnvVarsType;

try {
  // @ts-ignore
  envVars = import.meta.env as EnvVarsType;
  // envVars = process.env;
} catch {
  //
}

// @ts-ignore
if (!envVars) {
  envVars = {} as EnvVarsType;
}

export function setVars(value = {}) {
  envVars = { ...envVars, ...value } as EnvVarsType;
}

export function getVars(): Env {
  const vars = {} as Record<string, any>;

  for (const k in envVarsBase) {
    vars[k] = process.env[k];
  }

  return {
    ...vars,
    ...envVars,
  };
}
